var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2212_7976)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1249 6.40613H3.98274L9.45461 1.65613C9.54211 1.57957 9.48899 1.43738 9.37336 1.43738H7.99055C7.92961 1.43738 7.8718 1.45925 7.82649 1.49832L1.9218 6.62175C1.86772 6.66863 1.82435 6.72659 1.79462 6.79169C1.7649 6.85679 1.74951 6.92753 1.74951 6.9991C1.74951 7.07067 1.7649 7.1414 1.79462 7.2065C1.82435 7.27161 1.86772 7.32956 1.9218 7.37644L7.86086 12.5311C7.8843 12.5514 7.91242 12.5624 7.94211 12.5624H9.3718C9.48742 12.5624 9.54055 12.4186 9.45305 12.3436L3.98274 7.59363H13.1249C13.1937 7.59363 13.2499 7.53738 13.2499 7.46863V6.53113C13.2499 6.46238 13.1937 6.40613 13.1249 6.40613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2212_7976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousArrow);
export default __webpack_public_path__ + "static/media/previous-arrow.4716c4445b8b0703d56184921495a631.svg";
export { ForwardRef as ReactComponent };